/* Item Store */

import {
    createItemCategoryTemplate,
    createItemCategoryTemplateDefinition,
    createProduct,
    createProductAttribute,

    fetchItem,
    fetchItemAvailability,
    fetchItemOpenSalesOrders,
    fetchItemOpenOpportunities,
    fetchItemCategories,
    fetchCompleteItemCategoryTemplates,
    fetchItemCategoryTemplates,
    fetchItemCategoryTemplate,
    fetchProducts,
    fetchProduct,
    fetchProductCount,
    fetchProductAttributes,

    updateItemCategoryTemplate,
    updateItemCategoryTemplateDefinition,
    updateProduct,
    updateProductAttribute,

    deleteItemCategoryTemplate,
    deleteItemCategoryTemplateDefinition,

    checkProductExists,

    deleteProduct

} from '@/api'

const getInitialState = () => {
    return {
        categories: [],
        templates: [],
        completeTemplates: [],
        product: {},
        item: {},
        itemAvailability: [],
        itemOpenSalesOrders: [],
        itemOpenOpportunities: []
    }
}

let state = getInitialState()

const actions = {
    reset (context) {
        context.commit('resetState')
    },
    createItemCategoryTemplate (context, payload) {
        return createItemCategoryTemplate(payload)
    },
    createItemCategoryTemplateDefinition (context, payload) {
        return createItemCategoryTemplateDefinition(payload)
    },
    createProduct (context, payload) {
        return createProduct(payload)
    },
    createProductAttribute (context, payload) {
        return createProductAttribute(payload)
    },

    fetchCompleteItemCategoryTemplates (context, payload) {
        return fetchCompleteItemCategoryTemplates(payload).then(r => {
            context.commit('setCompleteItemCategoryTemplates', r.data)
        })
    },
    fetchItemCategories (context, payload) {
        return fetchItemCategories(payload).then(r => {
            context.commit('setItemCategories', r.data)
        })
    },
    fetchItemCategoryTemplates (context, payload) {
        return fetchItemCategoryTemplates(payload).then(r => {
            context.commit('setItemCategoryTemplates', r.data)
        })
    },
    fetchItemCategoryTemplate (context, categoryTemplateId) {
        return fetchItemCategoryTemplate(categoryTemplateId)
    },
    fetchProducts (context, payload) {
        return fetchProducts(payload).then(r => {
            context.commit('setProducts', r.data)
        })
    },
    fetchItem (context, item) {
        return fetchItem(item).then(r => {
            context.commit('setItem', r.data)
        })
    },
    fetchItemAvailability (context, item) {
        return fetchItemAvailability(item).then(r => {
            context.commit('setItemAvailability', r.data)
        })
    },
    fetchItemOpenSalesOrders (context, item) {
        return fetchItemOpenSalesOrders(item).then(r => {
            context.commit('setItemOpenSalesOrders', r.data)
        })
    },
    fetchItemOpenOpportunities (context, item) {
        return fetchItemOpenOpportunities(item).then(r => {
            context.commit('setItemOpenOpportunities', r.data)
        })
    },
    fetchProduct (context, productId) {
        return fetchProduct(productId).then(r => {
            context.commit('setProduct', r.data)
        })
    },
    fetchProductCount (context, payload) {
        return fetchProductCount(payload).then(r => {
            context.commit('setProductCount', r.data)
        })
    },
    fetchProductAttributes (context, productId) {
        return fetchProductAttributes(productId).then(r => {
            context.commit('setProductAttributes', r.data)
        })
    },

    updateItemCategoryTemplate (context, payload) {
        return updateItemCategoryTemplate(payload)
    },
    updateItemCategoryTemplateDefinition (context, payload) {
        return updateItemCategoryTemplateDefinition(payload)
    },
    updateProduct (context, payload) {
        return updateProduct(payload)
    },
    updateProductAttribute (context, payload) {
        return updateProductAttribute(payload)
    },

    deleteItemCategoryTemplate (context, categoryTemplateId) {
        return deleteItemCategoryTemplate(categoryTemplateId)
    },
    deleteItemCategoryTemplateDefinition (context, categoryTemplateDefinitionId) {
        return deleteItemCategoryTemplateDefinition(categoryTemplateDefinitionId)
    },

    checkProductExists (context, payload) {
        return checkProductExists(payload)
    },

    deleteProduct (context, productId) {
        return deleteProduct(productId).then(() => {
            context.commit('setProduct', {})
        })
    }
}

const mutations = {
    resetState (state) {
        const newState = getInitialState()
        for (let key in newState) {
            state[key] = newState[key]
        }
    },
    setItemCategories (state, payload) {
        state.categories = payload
    },
    setCompleteItemCategoryTemplates (state, payload) {
        state.completeTemplates = payload
    },
    setItemCategoryTemplates (state, payload) {
        state.templates = payload
    },
    setItem (state, payload) {
        state.item = payload
    },
    setItemAvailability (state, payload) {
        state.itemAvailability = payload
    },
    setItemOpenSalesOrders (state, payload) {
        state.itemOpenSalesOrders = payload
    },
    setItemOpenOpportunities (state, payload) {
        state.itemOpenOpportunities = payload
    },
    setProduct (state, payload) {
        state.product = payload
    },
    setProducts (state, payload) {
        state.products = payload
    },
    setProductCount (state, payload) {
        state.productCount = payload.count
    },
    setProductAttributes (state, payload) {
        state.product.attributes = payload
    }
}

const getters = {
    getItemCategories (state) {
        return state.categories
    },
    getCategoryTemplateNames (state) {
        const names = []
        for (let t of state.templates) {
            names.push(t.name)
        }
        return names
    },
    getCompleteCategoryTemplates (state) {
        return state.completeTemplates
    },
    getItemCategoryTemplates (state) {
        return state.templates
    },
    getProduct (state) {
        return state.product
    },
    getItem (state) {
        return state.item
    },
    getItemAvailability (state) {
        return state.itemAvailability
    },
    getItemOpenSalesOrders (state) {
        return state.itemOpenSalesOrders
    },
    getItemOpenOpportunities (state) {
        return state.itemOpenOpportunities
    },
    getProducts (state) {
        return state.products
    },
    getProductCount (state) {
        return state.productCount
    },
    getProductAttributes (state) {
        return state.product.attributes
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
